import { css } from '@emotion/css';
import { colors } from '@/colors';
import { SB400, Y400, Y500, N200 } from '@/colors/colorsV2';

const styIconColor = (color) => css`
  svg {
    stroke: ${color};
    fill: ${color};
    color: ${color};

    path,
    circle {
      stroke: ${color};
      fill: ${color};
    }
  }
`;

const styDisabledFilled = css`
  :disabled {
    color: ${colors.NEUTRAL_4};
    background: ${colors.NEUTRAL_2};
    border: 1px solid ${colors.NEUTRAL_2};

    ${styIconColor(colors.NEUTRAL_4)};
  }
`;

const styDisabledOutlined = css`
  :disabled {
    color: ${colors.NEUTRAL_4};
    background: ${colors.NEUTRAL_2};
    border: 1px solid ${colors.NEUTRAL_2};

    ${styIconColor(colors.NEUTRAL_4)};
  }
`;

const styPrimaryFilled = css`
  color: ${colors.NEUTRAL_0};
  background: ${colors.AJAIB_BLUE_5};
  border: 1px solid ${colors.AJAIB_BLUE_5};

  ${styIconColor(colors.NEUTRAL_0)};

  :hover,
  :focus {
    background: ${colors.AJAIB_BLUE_7};
    border: 1px solid ${colors.AJAIB_BLUE_7};
  }

  ${styDisabledFilled}
`;

const styPrimaryOutlined = css`
  color: ${colors.AJAIB_BLUE_5};
  background: ${colors.NEUTRAL_0};
  border: 1px solid ${colors.AJAIB_BLUE_5};

  ${styIconColor(colors.AJAIB_BLUE_5)};

  :hover,
  :focus {
    background: ${colors.AJAIB_BLUE_1};
  }

  ${styDisabledOutlined}
`;

const styGreyOutlined = css`
  color: ${colors.NEUTRAL_7};
  background: ${colors.NEUTRAL_0};
  border: 1px solid ${colors.NEUTRAL_3};

  ${styIconColor(colors.NEUTRAL_7)};

  :hover,
  :focus {
    background: ${colors.AJAIB_BLUE_1};
  }

  ${styDisabledOutlined}
`;

const styNaked = css`
  color: ${colors.AJAIB_BLUE_5};
  background: ${colors.NEUTRAL_0};
  border: 1px solid ${colors.NEUTRAL_0};

  ${styIconColor(colors.AJAIB_BLUE_5)};

  :hover,
  :focus {
    background: ${colors.AJAIB_BLUE_1};
    border: 1px solid ${colors.AJAIB_BLUE_1};
  }

  :disabled {
    color: ${N200};
  }
`;

const styNakedBlack = css`
  color: ${colors.NEUTRAL_10};
  background: ${colors.NEUTRAL_0};
  border: 1px solid ${colors.NEUTRAL_0};

  ${styIconColor(colors.NEUTRAL_10)};

  :hover,
  :focus {
    background: ${colors.AJAIB_BLUE_1};
    border: 1px solid ${colors.AJAIB_BLUE_1};
  }

  :disabled {
    color: ${N200};
  }
`;

const styNakedDanger = css`
  color: ${colors.RED_6};
  background: ${colors.NEUTRAL_0};
  border: 1px solid ${colors.NEUTRAL_0};

  ${styIconColor(colors.RED_6)};

  :hover,
  :focus {
    background: ${colors.RED_1};
    border: 1px solid ${colors.RED_1};
  }

  :disabled {
    color: ${N200};
  }
`;

const styCriticalFilled = css`
  color: ${colors.NEUTRAL_0};
  background: ${colors.RED_5};
  border: 1px solid ${colors.RED_5};

  ${styIconColor(colors.NEUTRAL_0)};

  :hover,
  :focus {
    background: ${colors.RED_6};
    border: 1px solid ${colors.RED_6};
  }

  ${styDisabledFilled}
`;

const styCriticalOutlined = css`
  color: ${colors.RED_6};
  background: ${colors.NEUTRAL_0};
  border: 1px solid ${colors.RED_6};

  ${styIconColor(colors.RED_6)};

  :hover,
  :focus {
    background: ${colors.RED_1};
  }

  ${styDisabledOutlined}
`;

const styCTA = css`
  color: ${SB400};
  background: ${Y400};
  border: 1px solid ${Y400};

  ${styIconColor(SB400)};

  :hover,
  :focus {
    background: ${Y500};
    border: 1px solid ${Y500};
  }

  ${styDisabledFilled}
`;

export const BUTTON_VARIANT = {
  primary: styPrimaryFilled,
  secondary: styPrimaryOutlined,
  tertiary: styGreyOutlined, // to be deprecated. use grey-outlined
  'grey-outlined': styGreyOutlined,
  naked: styNaked,
  'naked-black': styNakedBlack,
  'naked-danger': styNakedDanger,
  danger: styCriticalFilled,
  'danger-outline': styCriticalOutlined,
  cta: styCTA,
  topup: styCTA, // to be deprecated. use cta
};
